import { z } from 'zod';
import { validators } from '@huspy/forge/shared';

const { textFieldValidator } = validators;

export const createProposalSchema = z.object({
  client_external_id: z.string(),
  first_name: textFieldValidator,
  last_name: textFieldValidator,
  residency_status: textFieldValidator,
  employment_status: textFieldValidator,
});
